<template>
  <div class="terms-container">
    <article class="terms-content">
      

      <SimpleHeader 
          title="服務條款" 
          subtitle="生效日期：YYYY年MM月DD日"
        />

      <section class="terms-section">
        <p class="intro-text">歡迎您使用<span class="brand">[公司名稱]</span>（以下簡稱「我們」或「本公司」）提供的服務。在使用我們的服務之前，請您仔細閱讀本服務協議（以下簡稱「本協議」）。通過訪問或使用我們的服務，您同意遵守本協議的條款。</p>

        <div class="terms-article" v-for="(article, index) in termsArticles" :key="index">
          <h2 class="article-title">{{ article.title }}</h2>
          <div class="article-content">
            <p v-if="article.content">{{ article.content }}</p>
            <ul v-if="article.listItems" class="terms-list">
              <li v-for="(item, idx) in article.listItems" :key="idx">
                <span class="list-marker"></span>
                {{ item }}
              </li>
            </ul>
          </div>
        </div>

        <div class="contact-section">
          <h2 class="article-title">9. 聯繫我們</h2>
          <div class="contact-info">
            <div class="contact-item">
              <i class="bi bi-envelope"></i>
              <div>
                <span class="contact-label">電子郵件：</span>
                <a href="mailto:contact@company.com">contact@company.com</a>
              </div>
            </div>
            <div class="contact-item">
              <i class="bi bi-phone"></i>
              <div>
                <span class="contact-label">電話：</span>
                <a href="tel:+85212345678">+852 1234 5678</a>
              </div>
            </div>
            <div class="contact-item">
              <i class="bi bi-geo-alt"></i>
              <div>
                <span class="contact-label">地址：</span>
                <span>香港中環金融街8號國際金融中心</span>
              </div>
            </div>
          </div>
        </div>

        <footer class="terms-footer">
          <p class="closing-statement">感謝您選擇<span class="brand">[公司名稱]</span>的服務！</p>
        </footer>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      termsArticles: [
        {
          title: "1. 服務內容",
          content: "本公司提供的軟件開發、技術支持及相關服務（以下簡稱「服務」）旨在滿足客戶的需求。具體服務內容以雙方簽署的合同或訂單為準。"
        },
        {
          title: "2. 用戶義務",
          listItems: [
            "提供準確、真實和完整的信息",
            "不使用我們的服務進行任何非法活動或違反任何適用法律法規的行為",
            "不干擾或破壞我們的服務或伺服器的正常運行"
          ]
        },
        {
          title: "3. 知識產權",
          content: "本公司擁有與服務相關的所有知識產權，包括但不限於軟件、文檔、商標和其他材料。未經本公司書面許可，您不得複製、修改、分發或以其他方式使用這些知識產權。"
        },
        {
          title: "4. 服務費用",
          content: "服務費用將根據雙方簽署的合同或訂單進行約定。您同意按時支付所有費用，逾期付款可能會產生額外費用。"
        },
        {
          title: "5. 保密條款",
          content: "雙方同意對在服務過程中獲得的商業秘密和其他保密信息予以保密，未經對方書面同意，不得向任何第三方披露。"
        },
        {
          title: "6. 責任限制",
          content: "在法律允許的範圍內，本公司對因使用或無法使用服務而導致的任何間接、附帶、特殊或後果性損害不承擔責任。我們的責任僅限於您為服務支付的費用。"
        },
        {
          title: "7. 協議的修改",
          content: "本公司保留隨時修改本協議的權利。修改後的協議將在網站上發佈，並自發佈之日起生效。您繼續使用服務即表示接受修改後的協議。"
        },
        {
          title: "8. 適用法律",
          content: "本協議適用香港特別行政區法律。因本協議引起的爭議，雙方應友好協商解決；如協商不成，任何一方可向本公司所在地的法院提起訴訟。"
        }
      ]
    };
  }
};
</script>

<style scoped>
.terms-container {
  max-width: 1280px;
  margin: 0 auto;
  /* padding: 4rem 2rem; */
  font-family: 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.8;
  color: #2d3748;
}

.terms-header {
  text-align: center;
  margin-bottom: 3rem;
}

.main-title {
  font-size: 2.5rem;
  color: #1a2943;
  margin-bottom: 1rem;
}

.effective-date {
  color: #718096;
  font-size: 0.95rem;
}

.terms-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  padding: 3rem;
}

.intro-text {
  font-size: 1.1rem;
  margin-bottom: 2.5rem;
  color: #4a5568;
}

.brand {
  color: #3F81FE;
  font-weight: 600;
}

.terms-article {
  margin-bottom: 2.5rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e2e8f0;
}

.article-title {
  font-size: 1.5rem;
  color: #1a2943;
  margin-bottom: 1.5rem;
  position: relative;
  padding-left: 1.2rem;
}

.article-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.5em;
  width: 6px;
  height: 1.2em;
  background: #3F81FE;
  border-radius: 3px;
}

.terms-list {
  list-style: none;
  padding-left: 2rem;
  margin: 1.5rem 0;
}

.terms-list li {
  margin-bottom: 1rem;
  position: relative;
  padding-left: 2rem;
}

.list-marker {
  position: absolute;
  left: 0;
  top: 0.6em;
  width: 8px;
  height: 8px;
  background: #3F81FE;
  border-radius: 50%;
}

.contact-section {
  margin-top: 3rem;
  padding: 2rem;
  background: #f8fafc;
  border-radius: 8px;
}

.contact-info {
  margin-top: 1.5rem;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.contact-item i {
  font-size: 1.5rem;
  color: #3F81FE;
  margin-right: 1rem;
  width: 32px;
}

.contact-label {
  font-weight: 500;
  color: #1a2943;
}

.contact-item a {
  color: #3F81FE;
  text-decoration: none;
  transition: opacity 0.2s;
}

.contact-item a:hover {
  opacity: 0.8;
}

.terms-footer {
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #e2e8f0;
}

.closing-statement {
  font-size: 1.1rem;
  color: #4a5568;
}

@media (max-width: 768px) {
  .terms-container {
    padding: 2rem 1rem;
  }

  .main-title {
    font-size: 2rem;
  }

  .terms-section {
    padding: 2rem;
  }

  .article-title {
    font-size: 1.3rem;
  }

  .terms-list {
    padding-left: 1.5rem;
  }
}
</style>